import './InactiveUserGrid.scss'
import {
	Column, Item, Lookup
} from 'devextreme-react/data-grid';

import { Link } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { useAuth } from '../../../../contexts/auth';
import { useGetInactiveCompanyUsers } from '../api/get-inactive-users';
import { useMemo } from 'react';
import { CompanyTypes } from '../../../../types/enums';

export default function InactiveUserGrid() {

	const { user } = useAuth();
	const inactiveUsers = useGetInactiveCompanyUsers(user?.companyId!);
	const statusFilterItems = useMemo(() => {
		return [
			{
				text: 'Inactive',
				value: true
			},
			{
				text: 'Pending Inactive',
				value: false
			}
		]
	}, []);

	return (
		<>
			<SyncDataGrid
				stateStorageKey='inactive-user-grid'
				className={'dx-card wide-card'}
				dataSource={inactiveUsers.data?.users}
				keyExpr={['userName']}
				columnAutoWidth={false}
				wordWrapEnabled={true}
				additionalToolbarItems={[
					<Item
						location={'before'}
						key="grid-info"
					>
						<div className='inactive-users-info'>
							<div>Users are categorized as inactive after {inactiveUsers.data?.maxInactivityDays} days without logging in.</div>
							<div>To reactivate an account please contact <b>
								<a href={'mailto:' + inactiveUsers.data?.supportEmail}>{inactiveUsers.data?.supportEmail}</a></b>.
							</div>
						</div>
					</Item>
				]}
			>
				<Column
					dataField={'fullName'}
					caption={'Name'}
					dataType="string"
					cellRender={(cell: any) => {
						if (user?.companyTypeId === CompanyTypes.CFI)
							return <Link to={`/cfi/users/user/${encodeURIComponent(cell.data.userName)}`}>
								{cell.data.fullName}
							</Link>
						else
							return <>{cell.data.fullName}</>;
					}}
				/>
				<Column
					dataField={'userName'}
					caption={'User Name'}
					dataType="string"
				/>
				<Column
					dataField={'emailAddress'}
					caption={'Email Address'}
					dataType="string"
				/>
				<Column
					dataField={'phone'}
					caption={'Phone'}
					dataType="string"
				/>
				<Column
					dataField={'phoneExtension'}
					caption={'Phone Extension'}
					dataType="string"
				/>
				<Column
					dataField={'groups'}
					caption={'User Roles'}
					dataType="string"
					width={300}
				/>
				<Column
					dataField={'inactive'}
					caption={'Active Status'}
					dataType="string"
					cellRender={(row) => {
						return <span className={row.data.inactive ? '' : 'active-status-red'}>
							{row.data.inactive ? "Inactive" :
								`${row.data.daysToInactive} day${row.data.daysToInactive !== 1 ? 's' : ''} remaining active`}
						</span>;
					}}
				>
					<Lookup
						dataSource={statusFilterItems}
						displayExpr={'text'}
						valueExpr={'value'}
					/>
				</Column>
			</SyncDataGrid>

			<LoadPagePanel visible={inactiveUsers.isLoading} />
		</>
	)
} 
